import { Box, FormLabel, TextField } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/button';
import { H2 } from '../../../components/typography';
import { useAPI } from '../../../hooks/useAPI';
import { COLORS } from '../../../theme';

const EmailConfirmationOne = () => {
  const { t } = useTranslation();
  const queryParameters = new URLSearchParams(window.location.search);
  const { BFRApplicationAcceptance, isLoading } = useAPI();
  const applicationId = queryParameters.get('application-id');
  const isAccepted =
    queryParameters.get('is-accepted').toLowerCase() === 'true';

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [reason, setReason] = useState(null);

  const handleApplication = async () => {
    await BFRApplicationAcceptance({
      applicationId,
      isAccepted,
      reason
    });
    setIsSubmitted(true);
  };

  useEffect(() => {
    if (isAccepted) {
      handleApplication();
    }
  }, [isAccepted, handleApplication]);

  if (isLoading && isAccepted === null) {
    return (
      <Box>
        <CircularProgress />
      </Box>
    );
  }

  if (isSubmitted || isAccepted) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          my: 20
        }}
      >
        {isAccepted ? (
          <H2 fontWeight="bold">{t('email_conf_one_title_accepted')}</H2>
        ) : (
          <H2 fontWeight="bold">{t('email_conf_one_title_rejected')}</H2>
        )}
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <FormLabel id="inkomstOk">{t('reasonToRejection')}</FormLabel>
        <Box>
          <TextField
            multiline
            minRows={5}
            value={reason}
            sx={{ marginBottom: 3, marginTop: 1 }}
            onChange={(val) => setReason(val.target.value)}
          />
        </Box>
        <Button
          backgroundColor={COLORS.primary}
          textcolor={COLORS.white}
          onClick={handleApplication}
          isLoading={isLoading}
          disabled={!reason}
          sx={{ alignSelf: 'flex-end' }}
        >
          {t('submit')}
        </Button>
      </Box>
    </Box>
  );
};

export default EmailConfirmationOne;
